// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import moment from 'moment';
import Settings from '../../config.js';
import Auth from '../../services/Auth.js';
import pluralize from 'pluralize';

import { Container, Row, Col, Button, Alert, Badge, Tooltip, Form } from 'react-bootstrap';
import Panel from '../../components/lib/thss/Panel';
import ProfilePicture from '../../components/shared/elems/ProfilePicture';

// lib
import NumberFormat from 'react-number-format';
import Spinner from '../../components/lib/thss/Spinner';
import ObjectTypeItemsPanel from '../../components/lib/thss/json-schema-ui/ObjectTypeItemsPanel';

// shared
import PageHeaderWrapper from '../../components/shared/layout/PageHeaderWrapper';
import PanelHeaderWrapper from '../../components/shared/layout/PanelHeaderWrapper';
import PageContentWrapper from '../../components/shared/layout/PageContentWrapper';
import ButtonsToolbar from '../../components/shared/ButtonsToolbar';
import ValignMiddle from '../../components/lib/thss/ValignMiddle';
import FiltersToolbar from '../../components/shared/filters/FiltersToolbar';
import SlideDownTransition from '../../components/lib/thss/SlideDownTransition';
import MainHeading from '../../components/shared/MainHeading';
import ObjectTypePanel from '../../components/lib/thss/json-schema-form/ObjectTypePanel';
import FilterRestoreNotice from '../../components/shared/filters/FilterRestoreNotice';
import ListPageWrapper from '../../components/shared/ListPageWrapper';

// page-specific/etc.
import DataGrid from '../../components/lib/react-data-grid/lib/DataGrid';
import '../../components/lib/react-data-grid/dist/react-data-grid.css';

import ErrorPanel from '../../components/shared/ErrorPanel';

import Person from '../../components/shared/elems/Person';
import Business from '../../components/shared/elems/Business';

import Assignment from '../../components/shared/elems/Assignment';
import AddBondAssignmentForm from '../../components/bonds/AddBondAssignmentForm';

export default class BondAssignmentsPanel extends React.PureComponent {
  render() {
    const { typeData, data, formData, focus, fetching, saving, success, error, onToggleEdit, onChange, onSave, user, teammates, underwriter, onShowBondChange } = this.props;

    if (fetching) {
      return '';
    }
    if (!typeData) {
      return <ErrorPanel errors={[{message: 'No type data'}]} />
    }

    const typeName = typeData.type_name;

    // get basic info about type
    const label = typeData.label;
    const schema = typeData.schema;
    const layout = typeData.formLayout;
    const min = typeData.min;
    const max = typeData.max;

    const currAssignment = data ? [...data].reverse()[0] : null;
    const otherAssignments = data ? [...data].reverse().splice(1) : [];

    return (
      <>
        <ObjectTypeItemsPanel
          className={this.props.className || ''}
          style={this.props.style || {}}
          headerRenderer={(title) => {
            return (
              <h2 className="m-0 my-2">
                <div style={{display: 'inline-block', width: '1.5em'}}><i className={Settings.icons.objectTypes.assignments + ' text-muted'} /></div>

                {title}

                {/* <span className="sbm-bond__include-bond-checkbox float-right">
                  <Form.Check.Input id={typeName + '_includeBondData'}
                    type="checkbox"
                    checked={!!this.props.showBondData}
                    onChange={(e) => onShowBondChange(e.target.checked)} />

                  <Form.Check.Label for={typeName + '_includeBondData'}>Show all</Form.Check.Label>
                </span> */}
              </h2>
            )
          }}

          topSectionRenderer={() => {
            return (
              <>
                {
                  !currAssignment && (
                     <p>No one assigned</p>
                  )
                }
                {
                  currAssignment && currAssignment.assigned_to != Settings.NOBODY_USER_USERNAME && (
                    <Alert variant="warning">
                      <Alert.Heading>Current assignment</Alert.Heading>
                      <Assignment data={currAssignment} />
                    </Alert>
                  )
                }
                {
                  currAssignment && currAssignment.assigned_to == Settings.NOBODY_USER_USERNAME && (
                    <Alert variant="success">
                      <Alert.Heading><i className="fad fa-check mr-2" />No action required</Alert.Heading>
                    </Alert>
                  )
                }
              </>
            );
          }}

          typeName={typeName}
          label={label}
          schema={schema}
          layout={layout}

          data={otherAssignments}
          formData={formData}

          min={min}
          max={max}
          expandAdd={true}

          focus={focus}

          fetching={fetching}
          saving={saving}
          success={success}
          error={error}

          itemRenderer={(myTypeName, mySchema, myLayout, myItemData, isEditing, isFetching) => {
            if (!myItemData) {
              console.warn('WARNING: no item data while getting sidebar item');

              return <p>WARNING: no item data while getting sidebar item</p>;
            }

            return <Assignment data={myItemData} />
          }}

          insertFormOnTop={true}
          formRenderer={(typeName, schema, layout, formData, itemId, onChange, onSubmit, saving, success, error) => {
            return (
              <>
                {/* <h3 className="mt-4 mb-4"><i className="fad fa-plus mr-2" />Add assignment</h3> */}

                <hr />

                <AddBondAssignmentForm typeName={typeName} user={user} teammates={teammates} underwriter={underwriter} saving={saving} success={success} error={error} onChange={onChange} onSubmit={(formData, typeName) => onSave(typeName, itemId)} user={this.props.user} />

                <h3 className="mt-5 mb-4"><i className="fad fa-history mr-2" />Assignment log</h3>

                <hr />
              </>
            );
          }}

          onToggleEdit={onToggleEdit}
          onChange={onChange}
          onSave={onSave}
        />
      </>
    )
  }
}